import React, { useCallback } from 'react';

import Modal from '../../shared/modals/modal.component';

import { requiredWhenPresent } from '../../shared/propTypes';
import PropTypes from 'prop-types';

import {
  GLAccountPropTypes,
} from './GLAccountList.propTypes';
import { PeriodPropTypes } from '../../shared/propTypes/period';

const DeleteModal = ({
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingInProgress,
  period,
}) => {
  const removeGlAccountList = useCallback(() => {
    removeEntity({ ...entityToRemove, periodName: period.name }, { rowIndex });
  }, [removeEntity, entityToRemove, rowIndex, period]);

  return (
    <Modal
      className="delete-gl-account-list-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete GL Account"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeGlAccountList}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure you want to delete: <br /><br />
              List Name: {entityToRemove.listName}<br />
              GL Account: {entityToRemove.glAccount}<br />
            </div>
          )
          : null
      }
    </Modal>
  );
};

DeleteModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], GLAccountPropTypes),
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  isRemovingInProgress: PropTypes.bool.isRequired,
};

export default DeleteModal;
